import { IIdleTimer, useIdleTimer } from 'react-idle-timer'
import { debug } from '@util/log'
import {
  IDLE_STATE_INACTIVITY_MESSAGE,
  IDLE_STATE_LOGGED_OUT_MESSAGE,
  NUDGE_BEFORE_TIMEOUT_IN_MINUTES,
  TIME_OUT_IN_MINUTES,
} from '../../../constants'
import { LogoutFunction } from '@common/Login/typing'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@common/CustomToast'

const useIdle = (logout: LogoutFunction) => {
  const { showToast } = useToast()
  const navigate = useNavigate()
  const onAction = (event?: Event, idleTimer?: IIdleTimer) => {
    if (idleTimer?.isPrompted()) {
      idleTimer?.activate()
      debug('User did some action')
    }
  }

  const onActive = (event?: Event, idleTimer?: IIdleTimer) => {
    if (idleTimer?.isPrompted()) {
      debug('User is active again')
    }
  }

  const onPrompt = () => {
    if (Notification.permission !== 'denied') {
      const notification = new Notification(
        `You will be logged out due to inactivity in ${NUDGE_BEFORE_TIMEOUT_IN_MINUTES} minutes`
      )
      notification.onclick = () => {
        window.focus()
        notification.close()
      }
    }
    showToast({
      id: IDLE_STATE_INACTIVITY_MESSAGE,
      message: 'You will be logged out due to inactivity',
      type: 'warning',
    })
  }

  const onIdle = () => {
    showToast({
      id: IDLE_STATE_LOGGED_OUT_MESSAGE,
      message: 'You have been logged out due to inactivity.',
      type: 'error',
    })
    logout('timeout').finally(() => {
      navigate('/')
    })
  }
  const { start, pause } = useIdleTimer({
    name: 'patient-idle-timer',
    timeout: 1000 * 60 * TIME_OUT_IN_MINUTES,
    promptBeforeIdle: 1000 * 60 * NUDGE_BEFORE_TIMEOUT_IN_MINUTES,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
    onAction: onAction,
    onActive: onActive,
    onIdle: onIdle,
    onPrompt: onPrompt,
    startManually: true,
  })
  return { start, pause }
}

export default useIdle
